import React from 'react';
import PropTypes from 'prop-types';
import { ScreenReaderText } from '#/shared/components/Accessibility';
import * as Styled from './styled';

function RentalBadge({ company, color }) {
  return (
    <Styled.RentalBadge color={color}>
      <Styled.RentalCompanyIcon title={company} company={company} />
      <ScreenReaderText>{company}</ScreenReaderText>
    </Styled.RentalBadge>
  );
}

RentalBadge.propTypes = {
  company: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default RentalBadge;
